import React, { useContext, useState } from 'react'
import AllComponents from './components/AllComponents'
import { CartProvider, useCart } from 'react-use-cart'
import { apiValue } from './Data/AllData'
import Footer from './components/Footer';
import { Link } from 'react-router';

function Page() {
  const data = useContext(apiValue);

  const [search, setSearch] = useState(0)
  const getValue = (event) => {
    setSearch(event.target.value);
  }

  const { addItem } = useCart();
  return (
    <div>
      <AllComponents />

      <div>
        <div className="section properties mt-2">
          <div className="container">
            <div className="row properties-box">
              <div className="col-md-10 m-auto">
                <form>
                  <input type="search" name="search" placeholder="search" className="border-primary pl-2 form-control my-5" onChange={getValue} />
                </form>
              </div>
              {data.map((product) => {
                return search == 0 || product.id == search || product.name.toLowerCase().includes(search.toLowerCase()) ? (

                  <div className="col-lg-4 col-md-6 align-self-center mb-30 properties-items col-md-6 adv">
                    <div className="item">
                      <Link to={`/singleProduct/${product.id}`}>
                        <img src={product.image} height={'200px'} alt="" />
                      </Link>
                      <span className="category">{product.name}</span>
                      <h6>${product.price}</h6>
                      <h4>
                        <Link to={`/singleProduct/${product.id}`}>{product.description}</Link>
                      </h4>
                      <ul>
                        <li>
                          Id: <span>{product.id}</span>
                        </li>
                        <li>
                          Location: <span>{product.location}</span>
                        </li>
                        <li>
                          Rating: <span>{product.rating}</span>
                        </li>
                      </ul>
                      <div className="main-button">
                        <Link to={`/singleProduct/${product.id}`}>Details</Link>
                        <button onClick={() => addItem(product)}>ADD TO CART</button>
                      </div>
                    </div>

                  </div>

                ) : null
              })}
            </div>

          </div>
        </div>
      </div>

      <Footer />

    </div>
  )
}

function Products() {
  return (
    <CartProvider>
      <Page />
    </CartProvider>
  )
}

export default Products